// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3EKSrszakt","type":"nBnhYG-GJd"};
    if(module.hot) {
      // 1597843269355
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  